import { useQuery } from "@tanstack/react-query";
import { fetchMemberAssignments, type MemberAssignments } from "../api/firmWorkload";

export function useMemberAssignments(userId: string | undefined) {
  return useQuery<MemberAssignments>({
    queryKey: ["firm", "assignments", userId],
    queryFn: () => fetchMemberAssignments(userId as string),
    enabled: !!userId,
    staleTime: 60_000,
  });
}
